import script from "./ContractMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractMessages.vue?vue&type=script&setup=true&lang=js"

import "./ContractMessages.vue?vue&type=style&index=0&id=4b839e03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b839e03"]])

export default __exports__